import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./context/LanguageContext";
import ScrollToTop from "./components/ScrollToTop";
import NimnyLandingNew from "./pages/NimnyLandingNew";
import ContactPage from "./pages/ContactPage";
import PrivacyPage from "./pages/PrivacyPage";
import TermsPage from "./pages/TermsPage";
import AboutPage from "./pages/AboutPage";
import SubscriptionActionPage from "./pages/SubscriptionActionPage";
import LabApp from "./lab/LabApp";

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            {/* Homepage - New redesigned version */}
            <Route path="/" element={<NimnyLandingNew />} />
            
            {/* Contact - EN, RU, ES */}
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/ru/contact" element={<ContactPage />} />
            <Route path="/es/contact" element={<ContactPage />} />
            
            {/* Privacy - EN, RU, ES */}
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/ru/privacy" element={<PrivacyPage />} />
            <Route path="/es/privacy" element={<PrivacyPage />} />
            
            {/* Terms - EN, RU, ES */}
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/ru/terms" element={<TermsPage />} />
            <Route path="/es/terms" element={<TermsPage />} />
            
            {/* About - EN, RU, ES */}
            <Route path="/about-nimny" element={<AboutPage />} />
            <Route path="/ru/about-nimny" element={<AboutPage />} />
            <Route path="/es/about-nimny" element={<AboutPage />} />

            {/* Email consent and unsubscribe actions — intentionally noindex. */}
            <Route path="/updates/confirm/:token" element={<SubscriptionActionPage action="confirm" />} />
            <Route path="/updates/unsubscribe/:token" element={<SubscriptionActionPage action="unsubscribe" />} />

            {/* Private learning section — see /app/frontend/src/lab/LabApp.jsx
                Fully isolated. Has its own provider, its own state, and is
                excluded from search engines (noindex meta + robots.txt). */}
            <Route path="/lab/*" element={<LabApp />} />
          </Routes>
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
